import { applyMiddleware, createStore, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import appReducer from "reducers";
import rootSaga from "sagas";
import thunk from "redux-thunk";

// This is bad practice. We should not be creating a global store. This is used so VerseDataStore
// can access the store without being wrapped under the application's `<Provider>`.

function generateNewStore() {
  const sagaMiddleware = createSagaMiddleware({
    logger: () => {},
  });

  const composeEnhancers =
    (typeof window !== "undefined" &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;

  const newStore = createStore(
    appReducer,
    composeEnhancers(applyMiddleware(sagaMiddleware, thunk)),
  );

  sagaMiddleware.run(rootSaga);
  return newStore;
}

const store = generateNewStore();

export { generateNewStore as createStore };
export default store;
